import React from 'react';
import { observer } from 'mobx-react';
import UnitRatingsListFilter from './UnitRatingsListFilter';
import UnitRatingListService from '../../services/UnitRatingListService';

const UnitRatingsListFilterContainer = () => (
  <UnitRatingsListFilter
    values={UnitRatingListService.form.getValues()}
    onChange={UnitRatingListService.form.setValue}
    onSearch={UnitRatingListService.load}
    fetching={UnitRatingListService.fetch.fetching}
  />
);

export default observer(UnitRatingsListFilterContainer);
